/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, ReactNode } from 'react';

import { useLocation as useLocation } from '@tanstack/react-router';

// Material Dashboard 2 PRO React TS components
import MDBox from 'src/components/md/MDBox';

// Material Dashboard 2 PRO React context
import { useMaterialUIController, setLayout } from 'src/md-context';

// Declaring props types for PageLayout
interface Props {
  background?: 'white' | 'light' | 'default';
  children: ReactNode;
}

function PageLayout({ background = 'default', children }: Props) {
  const [, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'page');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- to be deleted, don't wanna mess with this
  }, [pathname]);

  return (
    <MDBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ overflowX: 'hidden' }}
    >
      {children}
    </MDBox>
  );
}

export default PageLayout;
